// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  width: 240px;
  height: auto;
  min-height: calc(100vh - 60px);
  align-self: stretch;
  background: #1e293b;
  color: white;
  font-family: Arial, sans-serif;
  overflow-y: auto; /*  enables vertical scroll */
}

@media (max-width: 1199px) {
  .sidebar {
    position: fixed;
    top: 60px;
    bottom: 0;
    left: 0;
    z-index: 1100;
    min-height: 0;
    transform: translateX(-100%);
    transition: transform 0.2s ease;
    box-shadow: 8px 0 24px rgba(15, 23, 42, 0.2);
  }

  .sidebar.sidebar-open {
    transform: translateX(0);
  }
}

.sidebar ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.menu-item {
  padding: 14px 18px;
  display: flex;
    align-items: center;
  justify-content: space-between;
  cursor: pointer;
}

.menu-item:hover {
  background: #334155;
}

.menu-badge {
  display: inline-block;
  margin-left: 7px;
  border-radius: 999px;
  padding: 2px 5px;
  background: #e36f4b;
  color: #fff;
  font-size: 9px;
  font-weight: 700;
  line-height: 1;
}

/* Submenu animation */
.submenu {
  max-height: 0;
  overflow: hidden;
  background: #0f172a;
  transition: max-height 0.3s ease;
}

.submenu.show {
  max-height: 300px;
}

.submenu-item {
  padding : 10px 40px !important ;
  font-size: 14px;
}

.submenu-item:hover {
  background: #1e293b;
}

/* Arrow rotation */
.arrow {
  transition: transform 0.3s ease;
}

.arrow.open {
  transform: rotate(180deg);
}

.link {
   display: flex;
  align-items: center;
  padding: 12px 16px;
  text-decoration: none;
  color: white;
}


/* Hover */
.menu-item:hover,
.link:hover {
  background: #334155;
}

/* Active */
.link.active {
  background: #2563eb;
}
/* Active route highlight */
.link.active li {
  background: #2563eb;
}

/* keep previous styles */
.submenu.show {
  max-height: 300px;
}
`, "",{"version":3,"sources":["webpack://./src/components/sidebar.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;EACZ,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,8BAA8B;EAC9B,gBAAgB,EAAE,6BAA6B;AACjD;;AAEA;EACE;IACE,eAAe;IACf,SAAS;IACT,SAAS;IACT,OAAO;IACP,aAAa;IACb,aAAa;IACb,4BAA4B;IAC5B,+BAA+B;IAC/B,4CAA4C;EAC9C;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;IACX,mBAAmB;EACrB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;GACG,aAAa;EACd,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;AACd;;;AAGA,UAAU;AACV;;EAEE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,mBAAmB;AACrB;AACA,2BAA2B;AAC3B;EACE,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;AACnB","sourcesContent":[".sidebar {\n  width: 240px;\n  height: auto;\n  min-height: calc(100vh - 60px);\n  align-self: stretch;\n  background: #1e293b;\n  color: white;\n  font-family: Arial, sans-serif;\n  overflow-y: auto; /*  enables vertical scroll */\n}\n\n@media (max-width: 1199px) {\n  .sidebar {\n    position: fixed;\n    top: 60px;\n    bottom: 0;\n    left: 0;\n    z-index: 1100;\n    min-height: 0;\n    transform: translateX(-100%);\n    transition: transform 0.2s ease;\n    box-shadow: 8px 0 24px rgba(15, 23, 42, 0.2);\n  }\n\n  .sidebar.sidebar-open {\n    transform: translateX(0);\n  }\n}\n\n.sidebar ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.menu-item {\n  padding: 14px 18px;\n  display: flex;\n    align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n}\n\n.menu-item:hover {\n  background: #334155;\n}\n\n.menu-badge {\n  display: inline-block;\n  margin-left: 7px;\n  border-radius: 999px;\n  padding: 2px 5px;\n  background: #e36f4b;\n  color: #fff;\n  font-size: 9px;\n  font-weight: 700;\n  line-height: 1;\n}\n\n/* Submenu animation */\n.submenu {\n  max-height: 0;\n  overflow: hidden;\n  background: #0f172a;\n  transition: max-height 0.3s ease;\n}\n\n.submenu.show {\n  max-height: 300px;\n}\n\n.submenu-item {\n  padding : 10px 40px !important ;\n  font-size: 14px;\n}\n\n.submenu-item:hover {\n  background: #1e293b;\n}\n\n/* Arrow rotation */\n.arrow {\n  transition: transform 0.3s ease;\n}\n\n.arrow.open {\n  transform: rotate(180deg);\n}\n\n.link {\n   display: flex;\n  align-items: center;\n  padding: 12px 16px;\n  text-decoration: none;\n  color: white;\n}\n\n\n/* Hover */\n.menu-item:hover,\n.link:hover {\n  background: #334155;\n}\n\n/* Active */\n.link.active {\n  background: #2563eb;\n}\n/* Active route highlight */\n.link.active li {\n  background: #2563eb;\n}\n\n/* keep previous styles */\n.submenu.show {\n  max-height: 300px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
